import { Anchor } from '@zillow/constellation-10';
import { FONT_TYPES, fontSizeMixin, token } from '@zillow/constellation';
import styled from 'styled-components';

export const ZillowNavbarSubSectionLinkAnchor = styled(Anchor)`
    font-family: ${token('fonts.sansSerif')};
    text-decoration: none;
    font-size: ${fontSizeMixin(FONT_TYPES.bodySmall)};
    color: ${token('colors.brand')};
    &:visited {
        color: ${token('colors.blue500')};
    }
    &:hover {
        text-decoration: underline;
        color: ${token('colors.brand')} !important;
    }
    &:visited:hover {
        color: ${token('colors.blue500')} !important;
        text-decoration: underline;
    }
`;
